import React, { Component } from 'react';
import { useAppointmentLabels } from '../../../App/customize/hooks/useAppointmentLabels';
import { useGetFacilityServices } from '../../../App/customize/hooks/useGetFacilityServices';
import moment from 'moment';
import { connect } from 'react-redux';

import NewAppointmentModal from './NewAppointmentModal';
import {
  rescheduleAppointment,
  getAppointmentById,
  clearAppointmentStore,
} from '../../../../redux/actions/appointmentAction';
import MessageModal from '../../../../shared/components/Modals/MessageModal';
import withRouter from '../../../../shared/components/withRouter';
import { DEFAULT_TIMESTAMP_FORMAT } from '../../../../constants/constants';

class RescheduleAppointment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetch: false,
      selectedParent: null,
      selectedPet: '',
      shareUpdates: false,
      appointmentDate: null,
      appointmentTime: null,
      time: '',
      appointmentType: '',
      appointmentTypeOther: '',
      doctor: null,
      referringDoctor: null,
      pet: null,
      errors: {
        appointmentDate: null,
        time: null,
        appointmentType: null,
        appointmentTypeOther: null,
        doctor: null,
        referringDoctor: null,
      },
      responseBox: {
        showResponse: false,
        responseType: '',
        responseAlertType: '',
        responseFooter: '',
        message: '',
        onSuccess: null,
      },
      isCreateOpen: true,
      saveSuccess: false,
      oldData: {
        appointmentDate: null,
        time: '',
        appointmentType: '',
        appointmentTypeOther: '',
        doctor: '',
        referringDoctor: '',
        shareUpdates: '',
      },
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleShareUpdates = this.handleShareUpdates.bind(this);
    this.handledateChange = this.handledateChange.bind(this);
    this.submit = this.submit.bind(this);
    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.validate = this.validate.bind(this);
    this.onClose = this.onClose.bind(this);
    this.rescheduleAppointment = this.rescheduleAppointment.bind(this);
    this.cancel = this.cancel.bind(this);
    this.resetData = this.resetData.bind(this);
  }

  componentDidMount() {
    this.props.clearAppointmentStore();
    this.props.getAppointmentById(this.props.params.appointmentId);
  }

  componentWillUnmount() {
    this.props.clearAppointmentStore();
  }

  returnToAppointments = () => {
    this.props.clearAppointmentStore();
    const appointmentsView = this.props.location?.state?.appointmentsView;
    if (appointmentsView) {
      this.props.navigate('/appointments', { state: { appointmentsView } });
    } else {
      this.props.navigate(-1);
    }
  };

  UNSAFE_componentWillReceiveProps(np) {
    const { responseBox, isFetch } = this.state;
    let { pet } = this.state;
    if (np.appointments && np.appointments.getAppointment && !isFetch) {
      const appointment = np.appointments.getAppointment;
      const routeId = String(this.props.params.appointmentId || '');
      const loadedId = String(appointment.id || appointment._id || '');
      if (!loadedId || loadedId !== routeId) {
        return;
      }
      const oldData = {
        appointmentDate: moment(appointment.dateTime).format(
          DEFAULT_TIMESTAMP_FORMAT,
        ),
        appointmentTime: moment(appointment.time, 'HH:mm'),
        time: moment(appointment.time, 'HH:mm').format('hh:mm A'),
        appointmentType: appointment.type,
        appointmentTypeOther: appointment.typeOther,
        doctor: appointment.doctor,
        referringDoctor: appointment.referringDoctor,
        shareUpdates: appointment.shareUpdates,
      };
      if (appointment.petData) {
        pet = appointment.petData;
      }

      this.setState({
        selectedParent: appointment.parent,
        selectedPet: appointment.pet,
        shareUpdates: appointment.shareUpdates,
        appointmentDate: moment(appointment.dateTime).format(
          DEFAULT_TIMESTAMP_FORMAT,
        ),
        appointmentTime: moment(appointment.time, 'HH:mm'),
        time: appointment.time,
        appointmentTypeOther: appointment.typeOther,
        appointmentType: appointment.type,
        doctor: appointment.doctor,
        referringDoctor: appointment.referringDoctor,
        isFetch: true,
        oldData,
        pet,
      });
    }

    if (np.appointments && np.appointments.rescheduleAppointment) {
      responseBox.showResponse = true;
      responseBox.responseFooter = true;
      responseBox.responseType = 'alert';
      responseBox.message = 'Appointment rescheduled';
      responseBox.onSuccess = this.onClose;

      this.setState({ saveSuccess: true, responseBox });

      setTimeout(() => {
        this.returnToAppointments();
      }, 2000);
    }
  }

  handleChange(e) {
    const fieldName = e.target.name;
    const state = this.state;
    state[fieldName] = e.target.value;
    if (fieldName === 'appointmentType') {
      state.appointmentTypeOther = '';
    }
    this.setState(state);
  }

  handleShareUpdates() {
    this.setState({ shareUpdates: !this.state.shareUpdates });
  }

  handledateChange(appointmentDate) {
    this.setState({ appointmentDate });
  }

  handleTimeChange = (time) => {
    if (time) {
      const appointmentTime = moment(time);
      this.setState({ appointmentTime });
    }
  };

  onChangeSelect(e, type, resetShareUpdates = false) {
    const state = this.state;

    if (!e) {
      state[type] = null;
      state.shareUpdates = false;
    } else {
      if (type === 'referringDoctor') {
        state.shareUpdates = !resetShareUpdates;
      }

      state[type] = e.value;
    }
    this.setState(state);
  }

validate() {
  const { appointmentDate, appointmentTime, appointmentType, errors } =
    this.state;
  const isBoardingOnly = !!this.props.isBoardingOnly;

  let dateTime = moment(appointmentDate);

  if (appointmentTime) {
    const dt = moment(appointmentDate).format(DEFAULT_TIMESTAMP_FORMAT);
    const apDate = `${dt} ${appointmentTime.format('HH:mm')}`;
    dateTime = moment(apDate);
  }

  const difference = dateTime.diff(moment.now());

  if (!appointmentDate) {
    errors.appointmentDate = 'Appointment date cannot be empty';
    this.setState({ errors });
    return true;
  }

  if (isBoardingOnly) {
    const selectedDay = moment(appointmentDate).startOf('day');
    if (!selectedDay.isValid()) {
      errors.appointmentDate = 'Appointment date is invalid';
      this.setState({ errors });
      return true;
    }
    if (selectedDay.isBefore(moment().startOf('day'))) {
      errors.appointmentDate = 'Appointment cannot be a past time';
      this.setState({ errors });
      return true;
    }
    errors.appointmentDate = null;
    this.setState({ errors });
  } else if (!dateTime.isValid()) {
    errors.appointmentDate = 'Appointment date is invalid';
    this.setState({ errors });
    return true;
  } else if (difference < 0) {
    errors.appointmentDate = 'Appointment cannot be a past time';
    this.setState({ errors });
    return true;
  } else {
    errors.appointmentDate = null;
    this.setState({ errors });
  }

    if (!appointmentTime) {
      errors.time = 'Appointment time cannot be empty';
      this.setState({ errors });
      return true;
    } else {
      errors.time = null;
      this.setState({ errors });
    }

    if (!appointmentType) {
      errors.appointmentType = 'Appointment type cannot be empty';
      this.setState({ errors });
      return true;
    } else {
      errors.appointmentType = null;
      this.setState({ errors });
    }
  }

  rescheduleAppointment() {
    const {
      shareUpdates,
      appointmentDate,
      appointmentType: type,
      doctor,
      referringDoctor,
      appointmentTime,
    } = this.state;

    this.onClose();
    this.props.rescheduleAppointment({
      appointmentId: this.props.params.appointmentId,
      appointmentDate: moment(appointmentDate).format(DEFAULT_TIMESTAMP_FORMAT),
      time: appointmentTime.format('hh:mm A'),
      type,
      typeOther: '',
      doctor,
      referringDoctor: referringDoctor === '' ? null : referringDoctor,
      shareUpdates,
    });
  }

  cancel() {
    this.returnToAppointments();
  }

  submit() {
    if (this.validate()) {
      return;
    }

    this.rescheduleAppointment();
  }

  onClose() {
    const { responseBox } = this.state;

    responseBox.showResponse = false;
    responseBox.responseType = '';
    responseBox.responseAlertType = '';
    responseBox.responseFooter = '';
    responseBox.message = '';
    responseBox.appointment = null;

    this.setState({ responseBox });

    this.props.clearAppointmentStore();
  }

  isDataChanged = () => {
    const {
      oldData,
      shareUpdates,
      appointmentDate,
      appointmentType: type,
      doctor,
      referringDoctor,
      appointmentTypeOther: typeOther,
      appointmentTime,
    } = this.state;

    return (
      JSON.stringify(oldData) !==
      JSON.stringify({
        appointmentDate: moment(appointmentDate).format(
          DEFAULT_TIMESTAMP_FORMAT,
        ),
        appointmentTime: moment(appointmentTime, 'HH:mm'),
        time: moment(appointmentTime, 'HH:mm').format('hh:mm A'),
        appointmentType: type,
        appointmentTypeOther: typeOther,
        doctor,
        referringDoctor,
        shareUpdates,
      })
    );
  };

  resetData(name) {
    const state = this.state;

    switch (name) {
      case 'referringDoctor':
        state.referringDoctor = '';
        state.shareUpdates = false;
        break;
      case 'referringDoctorAndDoctor':
        state.referringDoctor = '';
        state.doctor = '';
        state.shareUpdates = false;
        break;
      case 'doctor':
        state.doctor = '';
        break;
      default:
        break;
    }
    this.setState(state);
  }

  render() {
    const {
      selectedPet,
      appointmentDate,
      appointmentTime,
      time,
      appointmentType,
      appointmentTypeOther,
      doctor,
      referringDoctor,
      shareUpdates,
      errors,
      responseBox,
      isCreateOpen,
      saveSuccess,
      isFetch,
    } = this.state;

    return (
      <>
        <MessageModal
          show={responseBox.showResponse}
          type={responseBox.responseType}
          alertType={responseBox.responseAlertType}
          footer={responseBox.responseFooter}
          onSuccess={responseBox.onSuccess}
          onClose={this.onClose}
          appointment={responseBox.appointment}
          message={responseBox.message}
        />
        {isFetch && (
          <NewAppointmentModal
            isOpen
            onClose={this.cancel}
            reschedule
            petId={selectedPet}
            saveSuccess={saveSuccess}
            title={"Reschedule\nAppointment"}
            submitLabel="Reschedule"
            submitDisabled={!this.isDataChanged()}
            createData={{
              shareUpdates,
              appointmentDate,
              appointmentTime,
              time,
              appointmentType,
              appointmentTypeOther,
              doctor,
              referringDoctor,
              errors,
              collapse: isCreateOpen,
            }}
            handledateChange={this.handledateChange}
            handleTimeChange={this.handleTimeChange}
            onChangeSelect={this.onChangeSelect}
            handleShareUpdates={this.handleShareUpdates}
            handleChange={this.handleChange}
            resetData={this.resetData}
            submit={this.submit}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = {
  rescheduleAppointment,
  getAppointmentById,
  clearAppointmentStore,
};

function RescheduleAppointmentWithLabels(props) {
  const labels = useAppointmentLabels();
  const { data: services } = useGetFacilityServices();
  return (
    <RescheduleAppointment
      {...props}
      labels={labels}
      isBoardingOnly={services?.isBoardingOnly}
    />
  );
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RescheduleAppointmentWithLabels),
);
